import $ from "jquery";
import { emailRules, floatRules, phoneNumberRules } from "../abstracts/regex";

const componentsForm = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            main: ".js-form",
            btnOpenFile: ".js-button-open-file",
        };
        if ($(el.main).length === 0) return;

        $(document).on("submit", el.main, function (e) {
            const form = e.target;

            const input = $(this).find(`input`);

            let isValid = {};
            input.each(function () {
                const type = $(this).attr("type");
                const c_type = $(this).data("type");

                const value = $(this).val();
                const id = $(this).attr("id");

                const handleCondition = (condition) => {
                    if (condition) {
                        isValid[id] = "invalid";
                    } else {
                        delete isValid[id];
                    }
                }

                switch (c_type) {
                    case "float":
                        handleCondition(!floatRules.test(value))
                        break;

                    default:
                        break;
                }

                switch (type) {
                    case "email":
                        handleCondition(!emailRules.test(value))
                        break;
                    case "tel":
                        handleCondition(!phoneNumberRules.test(value))
                        break;

                    default:
                        break;
                }
            });

            if (!form.checkValidity() || Object.values(isValid).length > 0) {
                e.preventDefault();
                e.stopPropagation();
            }

            form.classList.add("Form--Validated");
        });

        $(document).on(
            "input",
            `${el.main} input, ${el.main} select, ${el.main} textarea`,
            function () {
                const c_type = $(this).data("type");
                const type = $(this).attr("type");
                const value = $(this).val();

                const handleCondition = (condition) => {
                    if (condition) {
                        $(this).addClass("invalid");
                    } else {
                        $(this).removeClass("invalid");
                    }
                }

                switch (c_type) {
                    case "float":
                        handleCondition(!floatRules.test(value))
                        break;

                    default:
                        break;
                }

                switch (type) {
                    case "email":
                        handleCondition(!emailRules.test(value))
                        break;
                    case "tel":
                        handleCondition(!phoneNumberRules.test(value))
                        break;

                    default:
                        break;
                }
            }
        );
    };
    init();
};

try {
    componentsForm();
} catch (error) {
    console.error("componentsForm", error);
}
